import { shareSNS } from './lib/_share.js';
import { kvMovie } from './lib/_kvMovie.js';
import { Scroll } from './lib/_scroll.js';

export var common = {
	scrl: "",
	beforeW: 0,
	init: ()=>{
		kvMovie.init();
		common.start();
		let startY = 0;
		
		window.addEventListener("touchstart", (e) => {
			startY = e.touches[0].pageY;
		}, { passive: false });
		
		/*
		window.addEventListener("touchmove", (e) => {
			const currentY = e.touches[0].pageY;
			const scrollTop = window.scrollY || document.documentElement.scrollTop;
		
			// ページ最上部 & 下方向フリック時に禁止
			if (scrollTop <= 0 && currentY > startY) {
				e.preventDefault(); // iOS Safari のバウンスやプルリロードを防止
			}
		}, { passive: false });
		*/
	},
	start: function(){
		let resizeFlag;
		let resizeTimer = null;
		let $body = document.getElementsByTagName('body')[0];
		
		common.resize();
		common.nav();
		common.scrl = new Scroll();
		
		/* window resize
		----------------------------- */
		var resizeCallback = function() {
			common.resize();
			resizeTimer = null;
		};
		window.addEventListener("resize", function(){
			if( !$body.classList.contains("resize") ){
				$body.classList.add("resize");
			}
			if(resizeTimer) {
				clearTimeout(resizeTimer);
			}
			resizeTimer = setTimeout(resizeCallback, 300);
		}, false);
	},
	nav: ()=>{
		let $btnMenu 	= document.querySelector("[data-menu]");
		if($btnMenu){
			//single handlers
			const eventListeners = [
				{ element: $btnMenu, type: "click", handler: common.toggleMenu}
			]
			eventListeners.forEach( ( el ) => {
				if(el.element){
					el.element.removeEventListener(el.type, el.handler, false);
					el.element.addEventListener(el.type, el.handler, false);
				}
			});
		}
	},
	toggleMenu: function(){
		let $html = document.documentElement;
		if( !$html.classList.contains("show-nav") ){
			$html.classList.add("show-nav");
		}else{
			$html.classList.remove("show-nav");
		}
	},
	resize: ()=>{
		var winW 	= window.innerWidth;
		var winH 	= window.innerHeight;
		let $body 	= document.getElementsByTagName('body')[0];
		
		addressbarH();
		kvMovie.resize(common.beforeW);
		common.getScrollBar();
		/*
		if(common.scrl){
			common.scrl.checkBlock();
			common.scrl.checkScroll();
		}
		*/
		
		let isPC = window.innerWidth >= 960;
		if( isPC ){
			let $accordions = document.querySelectorAll(".product_detail");
			$accordions.forEach( ($a, index) => {
				let panel = $a.querySelector("[data-accordion] .accordion_inner");
				$a.querySelector("[data-toggle-accordion]").setAttribute('aria-expanded', 'true');
				panel.hidden 		= false;
				panel.style.height 	= 'auto';
				$a.classList.add('is-open');
			});
		}else{
			
		}
		
		setTimeout(function(){
			if( $body.classList.contains("resize") ){
				$body.classList.remove("resize");
			}
			/*
			if(common.scrl){
				common.scrl.checkBlock();
				common.scrl.checkScroll();
			}
			*/
		},300);
		function addressbarH(){
			if(common.beforeW != winW){
				// 100vh、アドレスバーが出てる時に対応
				let vh = window.innerHeight * 0.01;
				document.documentElement.style.setProperty("--vh", `${vh}px`);
			}
		}
		common.beforeW = winW;
	},
	getScrollBar: function(){
		const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
		document.documentElement.style.setProperty('--scrollbar', `${scrollbarWidth}px`);
	},
	removeMultipleClass: function(dom, className){
		const target = document.querySelector(dom);
		const targetClassList = target.className;
		const myRegExp = new RegExp("/\b" + className + "\S+/", 'g');
		const myMatched = targetClassList.match(myRegExp) || [];
		for(let n = 0; n < myMatched.length; n++) {
		  target.classList.remove(myMatched[n]);
		}
	}
}
